import { render, staticRenderFns } from "./CellRendererDateTransfert.vue?vue&type=template&id=2b88ca2a&"
import script from "./CellRendererDateTransfert.vue?vue&type=script&lang=js&"
export * from "./CellRendererDateTransfert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports